module.exports = __webpack_public_path__ + "static/Nueng.7f1cff56.png";